import { render, staticRenderFns } from "./SettingSettings.vue?vue&type=template&id=031fd28e&"
import script from "./SettingSettings.vue?vue&type=script&lang=js&"
export * from "./SettingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports